import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchExamReviews, postExamReview } from '../services/examCategoryService';

export function useExamReviews(examsId, enabled = false) {
  const queryClient = useQueryClient();
  const queryKey = ['examReviews', Number(examsId)];
  const reviewsQuery = useQuery({
    queryKey,
    queryFn: () => fetchExamReviews(Number(examsId)),
    enabled: enabled && Number(examsId) > 0,
    staleTime: 60 * 1000,
  });
  const postReviewMutation = useMutation({
    mutationFn: postExamReview,
    onSuccess: () => queryClient.invalidateQueries({ queryKey }),
  });

  return { ...reviewsQuery, postReviewMutation };
}
